import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/analytics";

export function FinalCta() {
  return (
    <section className="relative overflow-hidden border-t border-navy-700 bg-navy py-20 lg:py-28" aria-labelledby="final-cta-heading">
      <p className="pointer-events-none absolute -right-8 top-1/2 hidden -translate-y-1/2 select-none font-mono text-[14rem] font-bold leading-none text-navy-700 lg:block" aria-hidden="true">
        $0<span className="text-[4rem]">/mo</span>
      </p>
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <h2 id="final-cta-heading" className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Stop Paying Subscriptions for{" "}
            <span className="text-teal-400">Documentation Software</span>
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-300 sm:text-lg">
            Equip your team with the prompts they need to do the job right.
          </p>
          <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
            <button
              type="button"
              data-testid="final-cta-pricing-button"
              onClick={() => scrollToId("pricing")}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-teal-600 px-9 py-4 font-display text-base font-semibold text-white shadow-lg transition-all hover:-translate-y-0.5 hover:bg-teal-500"
            >
              View Pricing &amp; Request Demo <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </button>
            <a
              href="mailto:sales@verachart.org"
              data-testid="final-cta-email-link"
              className="text-sm font-medium text-slate-300 underline decoration-teal-500 underline-offset-4 transition-colors hover:text-white"
            >
              sales@verachart.org
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
